import styled from 'styled-components';

export const StyledStepContentWrapper = styled.div<{}>`
  align-items: center;
  display: inline-flex;
  flex-direction: column;
`;
